import { render, staticRenderFns } from "./PaymentPlanSetup.vue?vue&type=template&id=c65fdcbe&scoped=true"
import script from "./PaymentPlanSetup.vue?vue&type=script&lang=js"
export * from "./PaymentPlanSetup.vue?vue&type=script&lang=js"
import style0 from "./PaymentPlanSetup.vue?vue&type=style&index=0&id=c65fdcbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65fdcbe",
  null
  
)

export default component.exports